import React, { FC } from 'react';
import { iconSize } from '../../../constants/icon.constants';
import ctaTypes from '../../../enums/CTA.enums';
import { targetLinkdsk } from '../../../utils/targetDskLink';
import CustomExternalAnchor from '../../@shared/customExternalAnchor';
import DownloadCTA from '../../@shared/downloadCTA';
import Icon from '../../@shared/icon';
import RoutableSitecoreLink from '../../@shared/routableSitecoreLink';
import { TCardCarouselSlideButtons } from '../types/cardCarousel.types';
import CTA from '../../@shared/CTA';

const CardCarouselSlideButtons: FC<TCardCarouselSlideButtons> = (props) => {
  const {
    isEE,
    validButtonPrimaryExists,
    validButtonSecondaryExists,
    isOfferCardWide,
    buttonPrimary,
    isWide,
    buttonSecondary,
    iconimage,
    downloadButtonLink,
    model,
    handleSplitModuleModal
  } = props;
  return (
    <div className="card-carousel__button-wrapper">
      {model?.showPopupWithSplitModule && model?.splitModuleLabel && (
        <CTA
          type={ctaTypes.brandPrimary}
          onClick={() => handleSplitModuleModal(true)}
          extraClassName="card-carousel__primary-btn"
        >
          {model.splitModuleLabel}
        </CTA>
      )}

      {(isEE || validButtonPrimaryExists) && (
        <div className="card-carousel__primary-btn">
          <RoutableSitecoreLink field={buttonPrimary} target={targetLinkdsk(buttonPrimary, isWide)} />
        </div>
      )}
      {(isOfferCardWide || !isWide || !validButtonPrimaryExists) && (
        <>
          {validButtonSecondaryExists && (
            <div className="slide-card__button slide-card__button--secondary">
              <span className="link-with-arrow">
                <CustomExternalAnchor field={buttonSecondary} target={targetLinkdsk(buttonSecondary, isWide)} />
                <Icon iconName={iconimage} color="primary" size={iconSize.dsk} />
              </span>
            </div>
          )}
          {!validButtonSecondaryExists && downloadButtonLink && (
            <DownloadCTA
              field={downloadButtonLink}
              type={ctaTypes['secondaryBlack']}
              extraClassName="slide-card__button slide-card__button--secondary"
            />
          )}
        </>
      )}
    </div>
  );
};

export default CardCarouselSlideButtons;
